module.exports = __webpack_public_path__ + "img/together-price-icon-small@2x.bd999877.png";